export function toClassificationPercent(score: number): number {
  if (!Number.isFinite(score)) {
    return 0;
  }
  return Math.round(Math.min(1, Math.max(0, score)) * 100);
}
